import { PEER } from '../../constants'

import { isUnifiedPlan } from '../../sdpUtils/sdpSemantics'
import { runPipeline } from '../../sdpUtils/pipeline'
import { removeTrickleIce, removeBundling, changeMediaDirection } from '../../sdpUtils/handlers'

/**
 * Creates an SDP offer.
 * @method createOffer
 * @param  {RTCOfferOptions} [options={}] Options used to customize the offer.
 * @param  {Object} [options.mediaDirections] Directions to use for media.
 * @param  {string} [options.mediaDirections.audio]
 * @param  {string} [options.mediaDirections.video]
 * @return {Promise} Resolves with the offer.
 */
export default function createOffer (options = {}) {
  const { nativePeer, config, log } = this
  log.info('Creating local offer.')

  // If using unified-plan, remove options.mediaDirections.
  // This is because directions are now set in transceivers.
  if (isUnifiedPlan(config.rtcConfig.sdpSemantics)) {
    delete options.mediaDirections
  }

  return new Promise((resolve, reject) => {
    nativePeer
      .createOffer(options)
      .then(offer => {
        const sdpHandlers = []
        if (config.trickleIceMode === PEER.TRICKLE_ICE.NONE) {
          // Modify the offer to claim the Peer doesn't support trickle ICE.
          sdpHandlers.push(removeTrickleIce)
        }
        if (config.removeBundling) {
          // Modify the offer to remove media bundling
          sdpHandlers.push(removeBundling)
        }
        if (options.mediaDirections) {
          // Modify the offer to set media directions as desired.
          sdpHandlers.push(changeMediaDirection(options.mediaDirections))
        }
        if (sdpHandlers.length > 0) {
          // Run the SDP pipeline with only these handlers.
          offer.sdp = runPipeline(sdpHandlers, offer.sdp, {
            type: offer.type,
            endpoint: PEER.ENDPOINT.LOCAL
          })
        }

        log.info('Finished creating local offer.')
        resolve(offer)
      })
      .catch(reject)
  })
}
